var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightSparkles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 87,
    viewBox: "0 0 85 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0579 61.5057C57.8059 62.8304 60.2969 62.4872 61.6216 60.7392C62.9463 58.9911 62.6031 56.5003 60.855 55.1756C59.107 53.8509 56.6161 54.1941 55.2914 55.9422C53.9667 57.6902 54.3099 60.1811 56.0579 61.5057Z",
    fill: "#8E4DD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.512 36.7091L65.0689 30.7324L58.3838 29.0338L64.3605 25.5907L66.0591 18.9055L69.5024 24.882L76.1874 26.5808L70.2106 30.0239L68.512 36.7091Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4974 61.38L7.0541 55.4035L0.369117 53.7047L6.34598 50.2614L8.04443 43.5764L11.4877 49.5529L18.1727 51.2517L12.1964 54.6949L10.4974 61.38Z",
    fill: "#00A98F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSparkles);
export default __webpack_public_path__ + "static/media/rightSparkles.85eb9f00eb412dd850b8d964d3433419.svg";
export { ForwardRef as ReactComponent };